/**
 * TODO: verify if this reducer is necessary... if we only render this data on a single page,
 * we can just fetch the data from the API and store it in the state.
 */

import { Project } from '@/lib/type'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ProjectState {
  projects: Project[]
  isLoading: boolean
}

export const mockProject: Project = {
  name: 'AI-generated name',
  description: 'Generated description',
}

const initialState: ProjectState = {
  projects: [mockProject],
  isLoading: false,
}

const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    setProjectLoading: (state: ProjectState, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    createProject: (state: ProjectState, action: PayloadAction<Project>) => {
      state.projects.push(action.payload)
    },
    deleteProject: (state: ProjectState, action: PayloadAction<number>) => {
      state.projects.splice(action.payload, 1)
    },
  },
})

export const { setProjectLoading, createProject, deleteProject } = projectSlice.actions

export default projectSlice.reducer
